import { UtilityService } from '../../../../../common/services/Utility.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

export class TimeConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên sự kiện',
        key: 'TIME_PERIOD_NAME',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời gian',
        key: 'display_time',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Lịch biểu',
        key: 'display_period',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static displayTimeColumns = period => {
    return `<span class="badge badge-default">${period.HFROM} - ${period.HTO}</span>`;
  };
  static displayDayOfWeekColumns = e => {
    if (!e.DAY_OF_WEEK) return '';
    let DAY_OF_WEEK_TRANSLATE = '';
    const tmp = e.DAY_OF_WEEK.split(',');
    tmp.forEach(m => {
      if (m == 0) {
        DAY_OF_WEEK_TRANSLATE += 'Chủ nhật, ';
      } else if (m == 1) {
        DAY_OF_WEEK_TRANSLATE += 'Thứ hai, ';
      } else if (m == 2) {
        DAY_OF_WEEK_TRANSLATE += 'Thứ ba, ';
      } else if (m == 3) {
        DAY_OF_WEEK_TRANSLATE += 'Thứ tư, ';
      } else if (m == 4) {
        DAY_OF_WEEK_TRANSLATE += 'Thứ năm, ';
      } else if (m == 5) {
        DAY_OF_WEEK_TRANSLATE += 'Thứ sáu, ';
      } else if (m == 6) {
        DAY_OF_WEEK_TRANSLATE += 'Thứ bảy, ';
      }
    });
    DAY_OF_WEEK_TRANSLATE = UtilityService.trimChar(DAY_OF_WEEK_TRANSLATE.trim(), ',');
    return DAY_OF_WEEK_TRANSLATE;
  };
  static displayDayColumns = e => {
    return moment(e).format('DD-MM-YYYY');
  };
  static displayPeriodColumns = period => {
    if (period.TIME_TYPE) {
      return `<span class="badge badge-default badge_primary">Các ngày trong tuần: ${period.DAY_OF_WEEK_TRANSLATE}</span>`;
    } else {
      return `<span class="badge badge-default badge_primary">Từ ngày: ${period.DATE_FROM_VN} đến ngày ${period.DATE_TO_VN}</span>`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/time/time.const.ts